import React from 'react';
import { Users, Sword, Gift, DollarSign } from 'lucide-react';
export function SaginawProgramsPricing() {
  const programs = [{
    icon: Users,
    name: 'Taekwondo',
    description: 'Traditional martial arts training for all ages and skill levels',
    pricing: 'First 2 weeks FREE',
    highlight: true
  }, {
    icon: Sword,
    name: 'Bo Staff Class',
    description: 'Weapons training for martial arts students',
    pricing: '$5 drop-in',
    highlight: false
  }, {
    icon: Users,
    name: 'Tang Soo Do',
    description: 'Korean martial art emphasizing striking techniques',
    pricing: 'Included with membership',
    highlight: false
  }];
  return <section className="py-16 bg-slate-50" data-id="element-656">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-657">
        <div className="text-center mb-12" data-id="element-658">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-659">
            Programs & Pricing
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-660">
            Discover our martial arts programs at Fashion Square Mall,
            conveniently located for families in the Saginaw area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-661">
          {programs.map((program, index) => <div key={index} className={`bg-white rounded-xl border-2 p-6 text-center ${program.highlight ? 'border-[#dc2626] shadow-md' : 'border-slate-200 shadow-sm'}`} data-id="element-662">
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full mb-4 ${program.highlight ? 'bg-[#dc2626]' : 'bg-slate-900'}`} data-id="element-663">
                <program.icon className="h-6 w-6 text-white" data-id="element-664" />
              </div>
              <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-665">
                {program.name}
              </h3>
              <p className="text-sm text-slate-600 mb-4" data-id="element-666">
                {program.description}
              </p>
              <div className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold ${program.highlight ? 'bg-[#dc2626] text-white' : 'bg-slate-100 text-slate-700'}`} data-id="element-667">
                {program.highlight && <Gift className="h-4 w-4 mr-2" data-id="element-668" />}
                {!program.highlight && program.pricing.includes('$') && <DollarSign className="h-4 w-4 mr-1" data-id="element-669" />}
                {program.pricing}
              </div>
            </div>)}
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 text-center" data-id="element-670">
          <p className="text-slate-600" data-id="element-671">
            <span className="font-bold text-[#1a2332]" data-id="element-672">Special Offer:</span> Get
            your first 2 weeks FREE for Taekwondo! Try our Bo Staff Class with a
            convenient $5 drop-in option every Saturday.
          </p>
        </div>
      </div>
    </section>;
}